/**
 * Maps a PartType enum value (as returned by the backend) to its i18n translation key.
 * @param type - The raw PartType string (e.g. "STORABLE_PRODUCT", "SERVICE", "CONSUMABLE")
 * @returns The i18n key to pass to t(), or undefined if the type is unknown/absent.
 */
export function getPartTypeI18nKey(type?: string): string | undefined {
    switch (type) {
        case "STORABLE_PRODUCT":
            return "common:partType:STORABLE_PRODUCT";
        case "SERVICE":
            return "common:partType:SERVICE";
        case "CONSUMABLE":
            return "common:partType:CONSUMABLE";
        default:
            return undefined;
    }
}
